import React, {Component} from "react"; 
import "../css/Login.css"
import "bootstrap/dist/css/bootstrap.min.css";
import Cookies from "universal-cookie";
import { useNavigate, useLocation } from "react-router-dom";

const cookies = new Cookies();


class Login extends Component {

   state={
      form: {
         userCorreo: "",
         userClave: ""
      }
   }

  
   handleChange= async (e) => {
      await this.setState({
         form: {
            ...this.state.form,
            [e.target.name]: e.target.value
         }
      });
      //console.log(this.state.form);
   }
 //https://smartcity.ibuxcloud.com

   iniciarSesion = async () => {
      const response = await fetch(`https://api.ibuxcloud.com/api/tb_users/login?usrcorreo=${this.state.form.userCorreo}&usrclave=${this.state.form.userClave}`, {
         mode: 'cors',
         method: 'POST',
         headers: {
             'Accept': 'application/json'
         }
      });

      if (!response.ok) {
         throw new Error('Problemas de comunicaciones con servidor de API');
      }
      const data = await response.json();
      console.log(data);

      if(data.length > 0){

         // la bienvenida
         window.alert(`Bienvenido:  ${data[0].usrnombre}`);

         // cargar a un cookies para que sea valorada en cada ventana o modulo o views 
         cookies.set("rolidx", data[0].rolidx, {path: "/"});
         cookies.set("usrcorreo", data[0].usrcorreo, {path: "/"});
         cookies.set("usrestado", data[0].usrestado, {path: "/"});
         cookies.set("usrfoto", data[0].usrfoto, {path: "/"});
         cookies.set("usridx", data[0].usridx, {path: "/"});
         cookies.set("usrnombre", data[0].usrnombre, {path: "/"});

         // uso de la cookies
         //window.alert(cookies.get('usrfoto'));

         // redireccionar al menu navbar

         window.location.href='https://jbteccr.net/testapp/#/Menup';

      } else {
         window.alert("Usuarios no Logeado, verificar")
      }
   }


   render() {
      return (
         <div className="containerPrincipal">
            <div className="containerSecundario">
               <div className="form-group">

                  <label>JC solo para pruebas de Routers AWS</label>
                  <br/>
                  <br/>

                  <label>Correo Electrónico</label>
                  <br/>
                  <input 
                     type="email"
                     className="form-control"
                     name="userCorreo"
                     onChange={this.handleChange}
                  />
                  <br/>

                  <label>Contraseña</label>
                  <br/>
                  <input 
                     type="password"
                     className="form-control"
                     name="userClave"
                     onChange={this.handleChange}
                  />
                  <br/>

                  <button className="btn btn-primary" onClick={() => this.iniciarSesion()} >Inicio de Sesión</button>
                  <br/>
                  <br/>  

               </div>
            </div>
         </div>
      );
   }
}

export default Login;